import React, { Component } from 'react';

export default class PageThree extends Component {
    render() {
        return <div className='wrapper-main'>PageThree</div>
    }
}


// WEBPACK FOOTER //
// ./src/pages/PageThree.js